module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/352.e96e6a78.png";